import AlertsviewTable from './alertsview-table'

const Alerts = () => <AlertsviewTable query={{}} />

export default Alerts
